export var sansSerif = 'DWFutura, sans-serif';
export var serif = 'DWCaslon, serif';